import React, { useState } from "react";
import {
  UserNoticeContainer,
  HeaderContainer,
  ContentContainer,
  NotificationContent,
} from "./EventsPrompt.styled";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

const EventsPrompt = ({
  handleClose,
  classIdentity,
  event,
}) => {
  const history = useHistory();
  const [user] = useState(getStateLoginComplete());

  let handleSeeDetails = (eventId) => {
    handleRedirectToHome();
    setTimeout(() => {
      history.push({
        pathname: `/DetailEvent`,
        state: { idEvent: eventId, event: {}, path: `/Activities` },
      });
    }, 1000);
  };
  let handleRedirectToHome = () => {
    history.push({
      pathname: `/Home`,
    });
  }
  const userInfo = {
    "blue-card":
      "just a gentle reminder that you have 7 days to complete your event.",
    "blue-card-3":
      "just a gentle reminder that you have 3 days to complete your event.",
    "yellow-card":
      "just a gentle reminder that you have 1 day to complete your event.",
    "red-card": "just a gentle reminder that you have to complete your event.",
  };
  return (
    <NotificationContent onClick={() => {
      handleClose(event?.idEvent);
      handleSeeDetails(event?.idEvent);
    }}
      className="container-notifi">
      <UserNoticeContainer classIdentity={classIdentity}>
        <HeaderContainer>
          {event.eventName}
        </HeaderContainer>
        <ContentContainer>
          <p>
            {event.description ?
              event.description :
              <>
                Hi {user?.displayName ?? "User"}, {userInfo[classIdentity]}
              </>
            }
          </p>
        </ContentContainer>
      </UserNoticeContainer>
    </NotificationContent>
  );
};

export default EventsPrompt;

EventsPrompt.propTypes = {
  handleClose: PropTypes.func,
  classIdentity: PropTypes.string,
  event: PropTypes.object
}